import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Keeps variant-dependent content in sync with the selected variant.
 * Wrap the content in <variant-refresh data-key="unique-key" data-product-id="…">. When a variant is selected, the
 * element replaces its children with the matching element from the freshly rendered section HTML.
 * Without JavaScript the server-rendered content for the initial variant stays in place.
 */
class VariantRefresh extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const key = this.dataset.key;
        if (!key) return;

        const replacement = html.querySelector(`variant-refresh[data-key="${CSS.escape(key)}"]`);
        if (!replacement) return;

        morph(this, replacement, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-refresh] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('variant-refresh')) {
  customElements.define('variant-refresh', VariantRefresh);
}
